export default "__VITE_ASSET__BoaY5Jay__"